/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TrackingTrackingModelsAnalyticsFileDetails,
    TrackingTrackingModelsAnalyticsFileDetailsFromJSON,
    TrackingTrackingModelsAnalyticsFileDetailsFromJSONTyped,
    TrackingTrackingModelsAnalyticsFileDetailsToJSON,
} from './';

/**
 * 
 * @export
 * @interface TrackingTrackingModelsAnalyticsDownloadAssetDetails
 */
export interface TrackingTrackingModelsAnalyticsDownloadAssetDetails {
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsDownloadAssetDetails
     */
    signature?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsDownloadAssetDetails
     */
    identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsDownloadAssetDetails
     */
    end_point?: string | null;
    /**
     * 
     * @type {Array<TrackingTrackingModelsAnalyticsFileDetails>}
     * @memberof TrackingTrackingModelsAnalyticsDownloadAssetDetails
     */
    file_list?: Array<TrackingTrackingModelsAnalyticsFileDetails> | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsDownloadAssetDetails
     */
    type?: string | null;
}

export function TrackingTrackingModelsAnalyticsDownloadAssetDetailsFromJSON(json: any): TrackingTrackingModelsAnalyticsDownloadAssetDetails {
    return TrackingTrackingModelsAnalyticsDownloadAssetDetailsFromJSONTyped(json, false);
}

export function TrackingTrackingModelsAnalyticsDownloadAssetDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingTrackingModelsAnalyticsDownloadAssetDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
        'identifier': !exists(json, 'identifier') ? undefined : json['identifier'],
        'end_point': !exists(json, 'end_point') ? undefined : json['end_point'],
        'file_list': !exists(json, 'file_list') ? undefined : (json['file_list'] === null ? null : (json['file_list'] as Array<any>).map(TrackingTrackingModelsAnalyticsFileDetailsFromJSON)),
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function TrackingTrackingModelsAnalyticsDownloadAssetDetailsToJSON(value?: TrackingTrackingModelsAnalyticsDownloadAssetDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signature': value.signature,
        'identifier': value.identifier,
        'end_point': value.end_point,
        'file_list': value.file_list === undefined ? undefined : (value.file_list === null ? null : (value.file_list as Array<any>).map(TrackingTrackingModelsAnalyticsFileDetailsToJSON)),
        'type': value.type,
    };
}


